import React, { FC } from 'react';
import cls from 'classnames';

import { ButtonChoiceProps } from './ButtonChoice.types';

export const classNames = {
	base: 'sds-button-choice',
	isSelected: 'is-selected',
	content: 'content',
};

const ButtonChoice: FC<ButtonChoiceProps> = (props) => {
	const {
		className,
		isSelected = false,
		children,
		disabled=false,
	} = props;

	return (
		<button
			className={cls(classNames.base, { [classNames.isSelected]: isSelected }, className)}
			onClick={props.onClick}
			data-testid={props['data-testid']}
			disabled={disabled}
			type='button'
		>
			{children}
		</button>
	);
};

ButtonChoice.displayName = 'ButtonChoice';

export default ButtonChoice;
